/** 通用类型定义 */

/** 分页响应 */
export interface PaginatedResponse<T> {
  code: number;
  message: string;
  data: T[];
  total: number;
  page: number;
  pageSize: number;
}

/** 通用API响应 */
export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

/** 用户角色 */
export enum UserRole {
  INTERNAL_OPS = 'INTERNAL_OPS',
  FIELD_OPS = 'FIELD_OPS',
  RISK_FINANCE = 'RISK_FINANCE',
  EXTERNAL_BUYER = 'EXTERNAL_BUYER',
  EXTERNAL_SUPPLIER = 'EXTERNAL_SUPPLIER',
  ECO_PARTNER = 'ECO_PARTNER',
}

/** 用户信息 */
export interface UserInfo {
  id: string;
  name: string;
  avatar: string;
  role: UserRole;
  permissions: string[];
  /** 后端 username（RBAC 登录后填充） */
  username?: string;
  /** 后端角色编码集合（如 ['admin']） */
  roles?: string[];
  /** 后端组织 ID */
  orgId?: string;
  /** 是否平台超管（决定「平台管理」入口可见性与跨租户权限） */
  isPlatformAdmin?: boolean;
}

/** 排序方向 */
export type SortDirection = 'asc' | 'desc';

/** 排序配置 */
export interface SortConfig {
  field: string;
  direction: SortDirection;
}

/** 分页参数 */
export interface PaginationParams {
  page: number;
  pageSize: number;
}

/** 通用下拉选项 */
export interface SelectOption {
  label: string;
  value: string;
}

/** 地址信息 */
export interface Address {
  country: string;
  city: string;
  address: string;
  postalCode: string;
}
